(function() { window.GUID_89488238_4edb_4194_bdb1_973421bb6773 = { getGuid: function() { return "89488238-4edb-4194-bdb1-973421bb6773"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class StatsGraph extends Controls.ControlBase {
            get ControlId() {
                return this.$control.attr('id');
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                let me = this;
                this.$control = $(params[0]);
            }
            OnBindEvents() {
            }
            OnDispose() {
                this.$control.remove();
            }
        }
        Controls.StatsGraph = StatsGraph;
        (function (StatsGraph) {
            class Events {
            }
            StatsGraph.Events = Events;
            class EventNames {
            }
            EventNames.Click = "button-click";
            StatsGraph.EventNames = EventNames;
        })(StatsGraph = Controls.StatsGraph || (Controls.StatsGraph = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=stats-graph.js.map
